var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['c--banners_referral', 'ltr:tw-bg-gradient-to-r rtl:tw-bg-gradient-to-l tw-from-[#ff5f6d] tw-to-[#ffc371]', 'tw-flex tw-justify-start tw-items-center tw-gap-5', 'tw-w-full tw-h-[75px]', 'tw-rounded tw-shadow', 'tw-px-5 tw-py-[15px]', 'tw-cursor-pointer', 'tw-text-white'],
    on: {
      "click": _vm.handleProfileBannerClick
    }
  }, [_c('i', {
    staticClass: "airalo-icon-referral-1 tw-text-11"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-justify-between tw-items-center tw-w-full"
  }, [_c('div', {
    staticClass: "tw-text-[14px]/[18px] tw-font-semibold"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('components.referral.banner.content.v2', {
    amount: _vm.giveAmount
  })) + "\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "rtl:tw-hidden airalo-icon-arrow-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "ltr:tw-hidden airalo-icon-arrow-left"
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }